/**
 * ...
 * @version 1.0.0
 * @exports InnovationRegisterForm
 */
export default class InnovationRegisterForm {
	/**
	 * Constructor
	 * @public
	 */
	constructor() {
		this.form = document.getElementById('innovation-register-form');
		if (this.form !== null) {
			this.initElems(this.form);
		}
	}

	initElems(form) {
		this.regionRadioButtons = form.querySelectorAll('input[name=radio-region]');
		this.submitButton = document.getElementById('innovation-register-submit');
		this.initEventListeners();
	}

	initEventListeners() {
		if (this.regionRadioButtons !== null) {
			for (let i = 0; i < this.regionRadioButtons.length; i++) {
				this.regionRadioButtons[i].addEventListener('change', function() {
					this.value === 'Nej'
						? (document.getElementById('region-dropdown').disabled = true)
						: (document.getElementById('region-dropdown').disabled = false);
				});
			}
		}
	}
}
